const marketLine = (nodes) =>
  Object.freeze({
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    nodes: Object.freeze(nodes)
  })

const marketFill = (nodes) =>
  Object.freeze({
    viewBox: '0 0 24 24',
    fill: 'currentColor',
    stroke: 'none',
    nodes: Object.freeze(nodes)
  })

export const icons = Object.freeze({
  dashboard: marketLine([
    { tag: 'rect', attrs: { x: 3, y: 3, width: 8, height: 8, rx: 2 } },
    { tag: 'rect', attrs: { x: 13, y: 3, width: 8, height: 5, rx: 2 } },
    { tag: 'rect', attrs: { x: 3, y: 13, width: 8, height: 8, rx: 2 } },
    { tag: 'rect', attrs: { x: 13, y: 10, width: 8, height: 11, rx: 2 } }
  ]),
  reports: marketLine([
    { tag: 'path', attrs: { d: 'M6 3H15L19 7V21H6C4.9 21 4 20.1 4 19V5C4 3.9 4.9 3 6 3Z' } },
    { tag: 'path', attrs: { d: 'M15 3V7H19M8 16V13M12 16V10M16 16V12' } }
  ]),
  trade: marketLine([
    { tag: 'path', attrs: { d: 'M4 7H20M16 3L20 7L16 11' } },
    { tag: 'path', attrs: { d: 'M20 17H4M8 13L4 17L8 21' } }
  ]),
  orders: marketLine([
    { tag: 'rect', attrs: { x: 4, y: 3, width: 16, height: 18, rx: 2 } },
    { tag: 'path', attrs: { d: 'M8 8L9.5 9.5L12 7M14 8H17M8 14L9.5 15.5L12 13M14 14H17' } }
  ]),
  profile: marketLine([
    { tag: 'circle', attrs: { cx: 12, cy: 8, r: 3.25 } },
    { tag: 'path', attrs: { d: 'M5 20C5.7 15.8 8.1 13.5 12 13.5C15.9 13.5 18.3 15.8 19 20' } }
  ]),
  avatar: marketFill([
    { tag: 'circle', attrs: { cx: 12, cy: 8, r: 4 } },
    {
      tag: 'path',
      attrs: { d: 'M3.75 21C4.35 15.85 7.35 13 12 13C16.65 13 19.65 15.85 20.25 21H3.75Z' }
    }
  ]),
  admin: marketLine([
    {
      tag: 'path',
      attrs: { d: 'M12 2.5L20 6V11.5C20 16.2 17.3 19.2 12 21.5C6.7 19.2 4 16.2 4 11.5V6L12 2.5Z' }
    },
    { tag: 'path', attrs: { d: 'M8.5 12L11 14.5L15.8 9.7' } }
  ]),
  return: marketLine([{ tag: 'path', attrs: { d: 'M20 12H5M10 7L5 12L10 17' } }]),
  home: marketLine([
    { tag: 'path', attrs: { d: 'M3.5 10.5L12 3L20.5 10.5V20.5H3.5V10.5Z' } },
    { tag: 'path', attrs: { d: 'M9 20.5V14H15V20.5' } }
  ]),
  language: marketLine([
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 9 } },
    {
      tag: 'path',
      attrs: {
        d: 'M3.5 9H20.5M3.5 15H20.5M12 3C9.6 5.5 8.5 8.5 8.5 12C8.5 15.5 9.6 18.5 12 21M12 3C14.4 5.5 15.5 8.5 15.5 12C15.5 15.5 14.4 18.5 12 21'
      }
    }
  ]),
  'chevron-right': marketLine([{ tag: 'path', attrs: { d: 'M9 5L16 12L9 19' } }]),
  'two-factor': marketLine([
    { tag: 'rect', attrs: { x: 4, y: 10, width: 14, height: 11, rx: 2 } },
    {
      tag: 'path',
      attrs: { d: 'M7 10V7C7 4.8 8.8 3 11 3C13.2 3 15 4.8 15 7V10M15.5 16L18 18.5L22 14.5' }
    }
  ]),
  'service-bot': marketLine([
    {
      tag: 'path',
      attrs: {
        d: 'M5 4H19C20.1 4 21 4.9 21 6V15C21 16.1 20.1 17 19 17H10L5 21V17C3.9 17 3 16.1 3 15V6C3 4.9 3.9 4 5 4Z'
      }
    },
    { tag: 'circle', attrs: { cx: 8, cy: 10.5, r: 0.75, fill: 'currentColor', stroke: 'none' } },
    { tag: 'circle', attrs: { cx: 12, cy: 10.5, r: 0.75, fill: 'currentColor', stroke: 'none' } },
    { tag: 'circle', attrs: { cx: 16, cy: 10.5, r: 0.75, fill: 'currentColor', stroke: 'none' } }
  ]),
  calendar: marketLine([
    { tag: 'rect', attrs: { x: 3, y: 5, width: 18, height: 16, rx: 2 } },
    { tag: 'path', attrs: { d: 'M3 10H21M8 3V7M16 3V7M7 14H10M14 14H17M7 18H10' } }
  ]),
  devices: marketLine([
    { tag: 'rect', attrs: { x: 2.5, y: 4, width: 13, height: 11, rx: 1.5 } },
    { tag: 'path', attrs: { d: 'M6 20H12M9 15V20' } },
    { tag: 'rect', attrs: { x: 17, y: 8, width: 4.5, height: 12, rx: 1 } }
  ]),
  terms: marketLine([
    { tag: 'path', attrs: { d: 'M6 3H15L19 7V21H6C4.9 21 4 20.1 4 19V5C4 3.9 4.9 3 6 3Z' } },
    { tag: 'path', attrs: { d: 'M15 3V7H19M8 12H15M8 16H13' } }
  ]),
  referral: marketLine([
    { tag: 'circle', attrs: { cx: 9, cy: 8, r: 3 } },
    {
      tag: 'path',
      attrs: {
        d: 'M3.5 19C4 15.6 5.9 14 9 14C12.1 14 14 15.6 14.5 19M15 7.5C15.5 6.6 16.4 6 17.5 6C19.4 6 21 7.6 21 9.5C21 11.4 19.4 13 17.5 13M16 15C18.9 15 20.5 16.3 21 19'
      }
    }
  ]),
  api: marketLine([
    { tag: 'rect', attrs: { x: 3, y: 4, width: 18, height: 16, rx: 2 } },
    { tag: 'path', attrs: { d: 'M9 8L5.5 12L9 16M15 8L18.5 12L15 16M14 7L10 17' } }
  ]),
  logout: marketLine([
    { tag: 'path', attrs: { d: 'M14 7V4H4V20H14V17M10 12H21M17 8L21 12L17 16' } }
  ]),
  'status-success': marketLine([
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 9 } },
    { tag: 'path', attrs: { d: 'M7.5 12L10.5 15L16.8 8.8' } }
  ]),
  'status-info': marketLine([
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 9 } },
    { tag: 'path', attrs: { d: 'M12 11V17' } },
    { tag: 'circle', attrs: { cx: 12, cy: 7.5, r: 0.8, fill: 'currentColor', stroke: 'none' } }
  ]),
  'status-warning': marketLine([
    { tag: 'path', attrs: { d: 'M12 3L21 20H3L12 3Z' } },
    { tag: 'path', attrs: { d: 'M12 9V14' } },
    { tag: 'circle', attrs: { cx: 12, cy: 17, r: 0.8, fill: 'currentColor', stroke: 'none' } }
  ]),
  'status-danger': marketLine([
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 9 } },
    { tag: 'path', attrs: { d: 'M8.5 8.5L15.5 15.5M15.5 8.5L8.5 15.5' } }
  ]),
  'crypto-transfer': marketLine([
    { tag: 'rect', attrs: { x: 3, y: 6, width: 16, height: 13, rx: 2 } },
    {
      tag: 'path',
      attrs: { d: 'M3 9H19M15 12H21V17H15C13.9 17 13 16.1 13 15V14C13 12.9 13.9 12 15 12Z' }
    },
    { tag: 'circle', attrs: { cx: 16, cy: 14.5, r: 0.7, fill: 'currentColor', stroke: 'none' } }
  ]),
  'cash-transfer': marketLine([
    { tag: 'rect', attrs: { x: 2.5, y: 5, width: 19, height: 14, rx: 2 } },
    { tag: 'circle', attrs: { cx: 12, cy: 12, r: 3 } },
    { tag: 'path', attrs: { d: 'M6 9H6.01M18 15H18.01' } }
  ]),
  'cta-arrow': marketLine([{ tag: 'path', attrs: { d: 'M4 12H20M14 6L20 12L14 18' } }]),
  check: marketLine([{ tag: 'path', attrs: { d: 'M4 12L9.5 17.5L20 6' } }]),
  'device-mobile': marketLine([
    { tag: 'rect', attrs: { x: 7, y: 2.5, width: 10, height: 19, rx: 2 } },
    { tag: 'line', attrs: { x1: 10, y1: 18, x2: 14, y2: 18 } }
  ]),
  'device-laptop': marketLine([
    { tag: 'rect', attrs: { x: 3, y: 4, width: 18, height: 13, rx: 1.5 } },
    { tag: 'path', attrs: { d: 'M1.5 21H22.5M8 17L7 21M16 17L17 21' } }
  ]),
  copy: marketLine([
    { tag: 'rect', attrs: { x: 8, y: 8, width: 12, height: 12, rx: 2 } },
    {
      tag: 'path',
      attrs: { d: 'M16 8V6C16 4.9 15.1 4 14 4H6C4.9 4 4 4.9 4 6V14C4 15.1 4.9 16 6 16H8' }
    }
  ])
})
